import { useEffect } from "react";

import { useLocation } from "react-router-dom";

type Options = {
    behavior?: ScrollBehavior;
};

export function useScrollToTop({ behavior = "auto" }: Options = {}) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [pathname, behavior]);
}
